export const environment = () => {
    return process.env.NODE_ENV;
};

export const isLocal = () => {
    return process.env.NODE_ENV === 'local';
};

export const isDev = () => {
    return process.env.NODE_ENV === 'development';
};

export const isProd = () => {
    return process.env.NODE_ENV === 'production';
};
